import React from 'react';
import { ArrowRight, MessageCircle, Phone } from 'lucide-react';
import Magnet from '../primitives/Magnet';

/**
 * Pill — central CTA atom. Variants drive visual hierarchy across the LP.
 * icon prop accepts a lucide-react component or one of the named shortcuts.
 */

const ICONS = {
  arrow: ArrowRight,
  whatsapp: MessageCircle,
  phone: Phone,
};

export default function Pill({
  variant = 'leaf',
  href,
  onClick,
  type,
  icon = 'arrow',
  iconLeft = false,
  magnet = true,
  magnetStrength = 0.3,
  children,
  className = '',
  testId,
  source,
  disabled,
  ...rest
}) {
  const variants = {
    leaf: 'pill pill-leaf',
    outline: 'pill pill-outline',
    light: 'pill pill-light',
    ghost: 'pill pill-ghost',
    dark: 'pill pill-dark',
  };
  const Icon = typeof icon === 'string' ? ICONS[icon] : icon;
  const cls = `${variants[variant] || variants.leaf} ${className}`;

  const inner = (
    <>
      {iconLeft && Icon ? <Icon className="w-4 h-4" /> : null}
      <span>{children}</span>
      {!iconLeft && Icon ? <Icon className="w-4 h-4" /> : null}
    </>
  );

  const sharedProps = {
    'data-testid': testId,
    'data-lead-source': source,
    className: cls,
    ...rest,
  };

  let el;
  if (href) {
    el = <a href={href} {...sharedProps}>{inner}</a>;
  } else {
    el = (
      <button type={type || 'button'} onClick={onClick} disabled={disabled} {...sharedProps}>
        {inner}
      </button>
    );
  }
  return magnet ? <Magnet strength={magnetStrength}>{el}</Magnet> : el;
}
